import axios from 'axios';
import { sha256 } from 'js-sha256';
import {rootUrl, ganBots, ganDeniedList} from './config';
import {contentLabelsMarking, contentBookMarking} from './content';
import * as EmailValidator from 'email-validator';
import {FavouriteProductsScrollList, BookmarkedContentScrollList} from './product_list';
import {removefromfv} from './basket';
import globalEvent from "./eventEmitter";

function bindMyPageEvents() {
  $("button[name='set_default']").on("click", function(){
    setDefaultAddress(this);
  });
  $("button[name='btn_new_cancel']").on("click", function(){
    cancelNewAddress(this);
  });

  $("button[name='btn_addr_remove']").on("click", function(){
    removeSelectedAddress(this);
  });
  $("button[name='btn_addr_new']").on("click", function(){
    addNewAddress(this);
  });
  $("button[name='btn_addr_save']").on("click", function(){
    updateSelectedAddress(this);
  });
  $("button[name='btn_chgPwd']").on("click", function(){
    changePwd(this);
  });
  $("input[name='newsletter_subs']").on("click", function(){
    subscriptionChange(this);
  });
  $("select[name='cust_addr']").on("change", function(){
    addSelectedChange(this);
  });

  $("table.order-tb tr.vc-row").on("click", function(){
    openOrderDetail(this);
  });
  $("ul.subs button.follow-act").on("click", function(){
    unsubLabel(this);
  });
  $("button.toggle-btn").on("click", function(){
    toggleOrderHistoryDetailMobile(this);
  });
  $("div[name='favourites']").on("click", function() {
    if (!$(".favourite-products-container .product-list-container").length) {
      FavouriteProductsScrollList();
    }
    if (!$(".bookmarked-articles-container .product-list-container").length) {
      BookmarkedContentScrollList();
    }
  })
}

function bindCustomerEvents(){
  // signin events
  $(".signin-popup button.cl-close-btn, .register-popup button.cl-close-btn").on("click", function(evt){
    evt.stopPropagation();
    $("div.signin-popup").remove();
    $("div.register-popup").remove();
  });
  $(".signin-popup button[name='btn_signin']").on("click", function(evt){
    evt.stopPropagation();
    loginCustomer(this);
  });

  $(".signin-popup a[name='btn_signin_seller']").on("click", function(evt){
    evt.stopPropagation();
    openSellerPopup(this);
  });

  $(".signin-popup button[name='btn_login_seller']").on("click", function(evt){
    evt.stopPropagation();
    loginSeller(this);
  });

  $(".register-popup button[name='btn_register']").on("click", function(evt){
    evt.stopPropagation();
    registerCustomer(this);
  });

  $("a[name='cl_forgot_pwd']").on("click", function(evt){
    evt.stopPropagation();
    forgotPwd(this);
    return false;
  });
  $("a[name='clresale_forgot_pwd']").on("click", function(evt){
    evt.stopPropagation();
    forgotResellerPwd(this);
    return false;
  });

  $("button[name='cl_register_member']").on("click", function(evt){
    evt.stopPropagation();
    $("div.signin-popup").remove();
    loadRegisterPopup(this);
    return false;
  });

  // ======= required logout events ============

  // navigate back to seller site when user hit cancel button
  $(".required-logout-popup button[name='btn_required_logout_cancel']").on("click", function(evt){
    evt.stopPropagation();
    navigateToSellerSite();
    unFreezeUI();
  });

  // logout when user hit ok button
  $(".required-logout-popup button[name='btn_required_logout_ok']").on("click", function(evt){
    evt.stopPropagation();
    logoutReseller(this);
    unFreezeUI();
  });
}

function openSellerPopup(ele) {
  loadSellerLoginPopup(ele);
}

function freezeUI() {
  $("body").LoadingOverlay("show",{
    image: "",
    text: "",
    background: "rgba(255,255,255,0.3)",
    zIndex: 1003,
    fade: false
  });
}

function unFreezeUI(){
  $("body").LoadingOverlay("hide",true);
}

function navigateToSellerSite() {
  location.href= "/seller/";
}

function bindCustomerToUI(data) {
  $("div.signin-popup").remove();
  if(data && data.html){
    $(data.html).insertAfter($("div.super-menu"));
  }
  bindCustomerEvents();
}

function openOrderDetail(ele){
  let order_id=$(ele).data("order-id");
  order_id = isNaN(order_id)?0:Number(order_id);
  if(order_id > 0){
    if($("tr.vc-dt-row.vc-row").length && Number($("tr.vc-dt-row.vc-row").attr("id")) == order_id) {
      closeAllOrderDetail()
      return;
    } else if ($("tr.vc-dt-row.vc-row").length && Number($("tr.vc-dt-row.vc-row").attr("id")) != order_id) {
      $(ele).siblings().removeClass("selected");
    }
    let url=`${rootUrl}/customer/mypage/getorder?order_id=${order_id}`;
    axios({url:url,method:'GET'}).then(function(res) {
      if(res.data && res.data.html){
        if($("tr.vc-dt-row.vc-row").length){
          $("tr.vc-dt-row.vc-row td>div").animate({height: '0px'}, 500, function(){
            $("tr.vc-dt-row.vc-row").remove();
            $(`<tr class="vc-dt-row vc-row" id="${order_id}"><td colspan="11" class="vc-col">${res.data.html}</td></tr>`).insertAfter($(ele).closest('tr'));
            $("tr.vc-dt-row.vc-row>td>div.order-history-detail").hide();
            $("button[name='btn_collapse']").on("click", function(){
              $("tr.vc-dt-row.vc-row").animate({height: '0px'}, 250, function(){
                $(this).closest("tr.vc-dt-row").prev().removeClass("selected");
                $(this).closest("tr.vc-dt-row").remove();
              });
            });
            $("tr.vc-dt-row.vc-row>td>div.order-history-detail").slideDown(500);
            $(ele).addClass("selected");
          });
        }else{
          $(`<tr class="vc-dt-row vc-row" id="${order_id}"><td colspan="11" class="vc-col">${res.data.html}</td></tr>`).insertAfter($(ele).closest('tr'));
          $("tr.vc-dt-row.vc-row>td>div.order-history-detail").hide();
          $("button[name='btn_collapse']").on("click", function(){
            $("tr.vc-dt-row.vc-row td>div").animate({height: '0px'}, 500, function(){
              $(this).closest("tr.vc-dt-row").prev().removeClass("selected");
              $(this).closest("tr.vc-dt-row").remove();
            });
          });
          $("tr.vc-dt-row.vc-row>td>div.order-history-detail").slideDown(500);
          $(ele).addClass("selected");
        }
      }
    }).catch(function(err){
      console.log(err);
    });
  }
}

function closeAllOrderDetail() {
  $("tr.vc-dt-row.vc-row>td>div.order-history-detail").slideUp(500, function() {
    $(this).closest("tr.vc-dt-row").prev().removeClass("selected");
    $(this).closest("tr.vc-dt-row").remove();
  });
}

let orders = [];

function toggleOrderHistoryDetailMobile(ele) {
  let orderId = $(ele).data("order-id");
  if ($(`div.orderhistory-card[data-order-id='${orderId}']`).attr("is-loading")) return;
  $(`div.orderhistory-card[data-order-id='${orderId}']`).attr("is-loading", true);
  orderId = isNaN(orderId)?0:Number(orderId);
  if (orderId > 0) {
    if ($(`#toggle_area_${orderId} .order-history-detail-mobile`).length > 0) {
      $(`#toggle_area_${orderId}`).animate({height: '0px'}, 250, function() {
        $(`#toggle_area_${orderId} .order-history-detail-mobile`).remove();
        $(`#toggle_area_${orderId}`).css("height", "unset");
        $(`div.orderhistory-card[data-order-id='${orderId}'] .action .close-up`).hide();
        $(`div.orderhistory-card[data-order-id='${orderId}'] .action .detail`).show();
        $(`div.orderhistory-card[data-order-id='${orderId}']`).removeAttr("is-loading");
      })
      return;
    }
    let url = `${rootUrl}/customer/mypage/getorder?is_mobile=true&order_id=${orderId}`;
    axios({url:url,method:'GET'}).then(function(res) {
      if (res.data && res.data.html) {
        $(`#toggle_area_${orderId}`).append(res.data.html);
        let toggleAreaHeight = $(`#toggle_area_${orderId}`).height();
        $(`#toggle_area_${orderId}`).height(0);
        if (!isNaN(toggleAreaHeight) && toggleAreaHeight > 0) {
          $(`#toggle_area_${orderId}`).animate({height: `${toggleAreaHeight}px`}, 250)
          $(`div.orderhistory-card[data-order-id='${orderId}'] .action .close-up`).show();
          $(`div.orderhistory-card[data-order-id='${orderId}'] .action .detail`).hide();
        }
      }
      $(`div.orderhistory-card[data-order-id='${orderId}']`).removeAttr("is-loading");
    }).catch(function(err) {
      console.log(err)
    })
  }
}


function addSelectedChange(ele){
  let addrId = $(ele).val();
  if (!addrId || addrId == "0") {
    console.log("remove this row and add new again")
    resetAllCustomerFields();
    $("button[name='btn_new_cancel']").removeClass("hide");
    $("button[name='btn_addr_new']").attr("disabled","disabled");
    $("button[name='set_default']").attr("disabled","disabled");
    $("button[name='btn_addr_remove']").attr("disabled","disabled");
    return true;
  }
  let url=`${rootUrl}/customer/mypage/addr?addrId=${addrId}`;
  axios({url:url,method:'GET'}).then(function(res) {
    console.log(res);
    if(res.data && res.data.status){
      let addr = res.data.addr;
      $(ele).val(addr.customer_address_id);
      $("input[name='first_name']").val(addr.first_name);
      $("input[name='last_name']").val(addr.last_name);
      $("input[name='address_1']").val(addr.address_1);
      $("input[name='address_2']").val(addr.address_2);
      $("input[name='postal_code']").val(addr.postal_code);
      $("input[name='city']").val(addr.city);
      $("select[name='country_code']").val(addr.country_code);
      if(!addr.is_default){
        $("button[name='set_default']").removeAttr("disabled");
        $("button[name='btn_addr_remove']").removeAttr("disabled");
        $("select[name='cust_title']").attr("disabled","disabled");
      }
      else {
        $("button[name='set_default']").attr("disabled","disabled");
        $("button[name='btn_addr_remove']").attr("disabled","disabled");
        $("select[name='cust_title']").removeAttr("disabled");
      }
    }
  }).catch(function(err){
    console.log(err);
  });
}

function setDefaultAddress(ele){
  let addr = {
    customer_id: $("input[name='customer_id']").val(),
    customer_address_id: $("select[name='cust_addr']").val()
  };
  let defText=$("select[name='cust_addr']").data("deftxt");
  let url=`${rootUrl}/customer/mypage/addrdef`;
  clearFieldError();
  axios({url:url,method:'POST',data:addr}).then(function(res) {
    if(res.data && res.data.status){
      let oDef=$(`select[name='cust_addr']>option[value='${res.data.oldDefId}']`);
      oDef.text(oDef.text().replace(defText,""));
      let cDef=$(`select[name='cust_addr']>option[value='${res.data.defAddr.customer_address_id}']`);
      cDef.text(defText+' '+res.data.defAddr.agg);
      $("button[name='set_default']").attr("disabled","disabled");
      $("button[name='btn_addr_remove']").attr("disabled","disabled");
      $("select[name='cust_title']").removeAttr("disabled");
    }
  }).catch(function(err){
    console.log(err);
  });
}

function subscriptionChange(ele) {
  let subsInfo = {
    isSub: $(ele).is(":checked"),
    email: $("input[name='email']").val()
  };
  console.log(subsInfo);
  let url=`${rootUrl}/customer/mypage/subscribe`;
  axios({url:url,method:'POST',data:subsInfo}).then(function(res) {
    if(res.data && res.data.status){
      console.log(res.data);
    }else{
      if(subsInfo.isSub) $(ele).removeAttr("checked");
      else $(ele).attr("checked","checked");
    }
  }).catch(function(err){
    console.log(err);
  });
}

function unsubLabel(ele) {
  let subsInfo = {
    label_id: $(ele).data("labelid"),
    email: $("input[name='email']").val(),
    isSub: Number($(ele).attr("data-issub"))==0
  };
  //console.log("IsSub = ",$(ele).attr("data-issub"));
  //console.log("Sub = ",subsInfo);
  let url=`${rootUrl}/customer/mypage/labelsubs`;
  axios({url:url,method:'POST', data:subsInfo}).then(function(res) {
    if(res.data && res.data.status) {
      //console.log(res.data);
      if(subsInfo.isSub) { $(ele).attr("data-issub","1"); $(ele)[0].innerHTML=$(ele).data("fledtxt"); $(ele).addClass("subscribed").removeClass("not-subscribed"); }
      else { $(ele).attr("data-issub","0"); $(ele)[0].innerHTML=$(ele).data("fltxt"); $(ele).addClass("not-subscribed").removeClass("subscribed");}
    }
  }).catch(function(err){
    console.log(err);
  });
}

function removeSelectedAddress(ele){
  let addr = {
    customer_id: $("input[name='customer_id']").val(),
    customer_address_id: $("select[name='cust_addr']").val()
  };
  console.log(addr);
  let url=`${rootUrl}/customer/mypage/addr`;
  clearFieldError();
  $(ele).attr("disabled","disabled");
  axios({url:url,method:'DELETE',data:addr}).then(function(res) {
    if(res.data && res.data.status){
      let cDef=$(`select[name='cust_addr']>option[value='${addr.customer_address_id}']`);
      cDef.remove();
      $("select[name='cust_addr']").val(res.data.selId);
      $("select[name='cust_addr']").trigger("change");
    } else addressChangeFailed(res);
  }).catch(function(err){
    console.log(err);
  }).finally(function() {
    $(ele).removeAttr("disabled");
  });
}

function cancelNewAddress() {
  let newAddOpt=$(`select[name='cust_addr']>option[value='0']`);
  newAddOpt.remove();
  $("select[name='cust_addr']").val($("button[name='btn_new_cancel']").val()).trigger('change');
  $("button[name='btn_new_cancel']").addClass("hide");
  $("button[name='btn_addr_new']").removeAttr("disabled");
}

function addNewAddress(ele){
  $("button[name='btn_new_cancel']").val($("select[name='cust_addr']").val());
  let newText = $("select[name='cust_addr']").data("newtxt");
  $("select[name='cust_addr']").append(`<option value="0">${newText}</option>`);
  $("select[name='cust_addr']").val(0);
  $("input[name='first_name']").val('');
  $("input[name='last_name']").val('');
  $("input[name='address_1']").val('');
  $("input[name='address_2']").val('');
  $("input[name='postal_code']").val('');
  $("input[name='city']").val('');
  $("select[name='country_code']").val('SE');
  $("input[name='first_name']").focus();
  $("button[name='btn_new_cancel']").removeClass("hide");
  $("button[name='btn_addr_new']").attr("disabled","disabled");
  $("button[name='btn_new_cancel']").removeClass("hide");
  $("button[name='set_default']").attr("disabled","disabled");
  $("button[name='btn_addr_remove']").attr("disabled","disabled");
  $("select[name='cust_title']").attr("disabled","disabled");
  clearFieldError();
}

function updateSelectedAddress(ele){
  let addr = {
    customer_id: $("input[name='customer_id']").val(),
    customer_address_id: $("select[name='cust_addr']").val(),
    address_1: $("input[name='address_1']").val(),
    address_2: $("input[name='address_2']").val(),
    postal_code: $("input[name='postal_code']").val(),
    city: $("input[name='city']").val(),
    country_code: $("select[name='country_code']").val(),
    country: $("select[name='country_code']>option:selected").text(),
    first_name: $("input[name='first_name']").val(),
    last_name: $("input[name='last_name']").val(),
    btitle: $("select[name='cust_title']").val()
  };
  let url=`${rootUrl}/customer/mypage/addr`;
  let defText=$("select[name='cust_addr']").data("deftxt");
  clearFieldError();
  $(ele).attr("disabled","disabled");
  axios({url:url,method:'POST',data:addr}).then(function(res) {
    console.log(res.data);
    if(res.data && res.data.status){
      let cDef=$(`select[name='cust_addr']>option[value='${addr.customer_address_id}']`);
      if(res.data.updatedAdd.is_default)  cDef.text(defText+' '+res.data.updatedAdd.agg);
      else {
        cDef.text(res.data.updatedAdd.agg);
        $("button[name='set_default']").removeAttr("disabled");
    }
      if (res.data.getRes && res.data.getRes.addr && res.data.getRes.addr.customer_address_id) {
        cDef.attr('value', res.data.getRes.addr.customer_address_id)
        $("button[name='btn_new_cancel']").addClass("hide");
        $("button[name='btn_addr_new']").removeAttr("disabled");
      }
    } else addressChangeFailed(res);
  }).catch(function(err){
    console.log(err);
  }).finally(function() {
    $(ele).removeAttr("disabled");
  });
}

function addressChangeFailed(res) {
  if (res.data && res.data.errorFields) {
    for (var i in res.data.errorFields) {
      setFieldError(res.data.errorFields[i])
    }
  }
  if (res.data.msg) {
    $("div[id='customer_info'] div.m-col1 div[name='general_notification']").text(res.data.msg);
    $("div[id='customer_info'] div.m-col1 div[name='general_notification']").addClass("mp-err");
    $("div[id='customer_info'] div.m-col1 div.wrapper").addClass("mp-field-err");
  }
}

function clearFieldError() {
  $("input[name='address_1']").removeClass("mp-field-err")
  $("div[name='err_address_1']").remove();

  $("input[name='city']").removeClass("mp-field-err")
  $("div[name='err_city']").remove();

  $("select[name='country_code']").removeClass("mp-field-err")
  $("div[name='err_country_code']").remove();

  $("input[name='first_name']").removeClass("mp-field-err")
  $("div[name='err_first_name']").remove();

  $("input[name='last_name']").removeClass("mp-field-err")
  $("div[name='err_last_name']").remove();

  $("input[name='postal_code']").removeClass("mp-field-err")
  $("div[name='err_postal_code']").remove();

  $("div[id='customer_info'] div.m-col1 div[name='general_notification']").removeClass("mp-err")
  $("div[id='customer_info'] div.m-col1 div.wrapper").removeClass("mp-field-err");
  $("div[id='customer_info'] div.m-col1 div[name='general_notification']").text("");
  return true;
}

function setFieldError(field) {
  if (field.fieldName != "country_code") {
    $(`input[name='${field.fieldName}']`).addClass("mp-field-err")
    $(`<div name="err_${field.fieldName}" class="mp-txt mp-exp mp-err">${field.msg || ""}</div>`).insertAfter($(`input[name='${field.fieldName}']`))
  } else {
    $(`select[name='${field.fieldName}']`).addClass("mp-field-err")
    $(`<div name="err_${field.fieldName}" class="mp-txt mp-exp mp-err">${field.msg || ""}</div>`).insertAfter($(`select[name='${field.fieldName}']`))
  }
}

function changePwd(ele){
  let url=`${rootUrl}/customer/mypage/chgpwd`;
  $(".chgpwd-form div.cl-error").html("");
  if(!$("input[name='curPwd']").val()){
    $(".chgpwd-form div.cl-error").html(`${$("input[name='curPwd']").data("invalid-msg")}`);
    return;
  }
  if(!$("input[name='newPwd']").val()){
    $(".chgpwd-form div.cl-error").html(`${$("input[name='curPwd']").data("invalid-msg")}`);
    return;
  }
  if($("input[name='cfmPwd']").val() != $("input[name='newPwd']").val()){
    $(".chgpwd-form div.cl-error").html(`${$("input[name='cfmPwd']").data("invalid-msg")}`);
    return;
  }

  const cId=$("input[name='customer_id']").val();
  const hashPwd = sha256($("input[name='curPwd']").val());
  const newHashPwd = sha256($("input[name='newPwd']").val());
  axios({url:url,method:'POST',data:{customer_id: cId, pwd: hashPwd, newpwd: newHashPwd}}).then(function(res) {
    if(res.data.status){
      $(".chgpwd-form div.cl-error").html(`${res.data.msg}`);
    }else{
      $(".chgpwd-form div.cl-error").html(`${res.data.errorMsg}`);
    }
  }).catch(function(err){
    console.log(err);
  });
}

function loadLoginPopup(ele){
  let requester=$(ele).attr("name");
  if(!requester && $(ele).hasClass("wex-right-panel")) requester = $(ele).find("button[name='cust_info']").attr("name");
  let url=`${rootUrl}/customer/getLogin?requester=${requester}`;
  axios({url:url,method:'GET'}).then(function(res) {
    bindCustomerToUI(res.data);
  }).catch(function(err){
    console.log(err);
  });
}

function loadSellerLoginPopup(ele){
  let requester=$(ele).attr("name");
  if(!requester && $(ele).hasClass("wex-right-panel")) requester = $(ele).find("button[name='cust_info']").attr("name");
  let url=`${rootUrl}/customer/getSellerLogin?requester=${requester}`;
  axios({url:url,method:'GET'}).then(function(res) {
    bindCustomerToUI(res.data);
  }).catch(function(err){
    console.log(err);
  });
}

function displayLogoutPopup() {
  freezeUI();
  let url = `${rootUrl}/customer/getLogout`;
  axios({url:url, method: "GET"}).then((res) => {
    bindCustomerToUI(res.data);
  }).catch((err) => {
    console.log(err);
  })
}

function loadRegisterPopup(ele){
  let url=`${rootUrl}/customer/getRegister`;
  axios({url:url,method:'GET'}).then(function(res) {
    console.log(res);
    bindCustomerToUI(res.data);
  }).catch(function(err){
    console.log(err);
  });
}

function loginSuccess(data) {
  if(data.redirect_url) location.href=data.redirect_url;
  else {
    $("div.signin-popup").remove();
    $("div.user-info-txt").html(data.title_text);
    $("button[name='cust_info']").val(data.customer_id);
    $("button[name='cust_info'] i").removeClass("fa-sign-in").addClass("fa-user");
    $("button[name='cust_info']").attr("data-mypage",data.mypageUrl);
    contentLabelsMarking({email: data.userInfo.email_work});
    contentBookMarking();
    checkProductIsFv();
    renderAdditionalFullWishlist();
  }
}

function checkLoggedCustomer() {
  //if(Number($("div#customer_logged_id").data("cust-id")) > 0){
    let url=`${rootUrl}/customer/checkloggedinuser`;
    $("div#customer_logged_id").removeAttr("data-mypage");
    $("button[name='customer_login']").removeAttr("data-mypage");
    $("img.my-page").attr("src","/images/system/mypage_outline.jpg");
    $("div#customer_logged_id span").html($("div#customer_logged_id").attr("data-login-txt"));
    axios({url:url,method:'POST'}).then(function(res) {
      let data = res.data;
      $("div#customer_logged_id").attr("data-cust-id",data.customer_id);
      $(".mobile-menu-wrapper button[name='customer_login']").text(data.title_text);
      $("div.user-info-txt").html(data.title_text);

      if (data && data.required_logout) {
        displayLogoutPopup();
        return;
      }

      if(data && data.status){
        contentLabelsMarking(data);
        contentBookMarking();
        if(data.redirect_url){
          $("div#customer_logged_id").attr("data-mypage",data.redirect_url);
          $("div#customer_logged_id").attr("data-cust-id",data.customer_id);
          $("button[name='customer_login']").attr("data-mypage",data.redirect_url);
          $("div#customer_logged_id span").html($("div#customer_logged_id").attr("data-mypage-txt"));
          $(".mobile-menu-wrapper button[name='customer_login']").attr("data-url",data.redirect_url);
          $("img.my-page").attr("src","/images/system/mypage_fill.jpg");
        }
      }
    }).catch(function(err){
      console.log(err);
    });
  //}
}

function loginFailed(data) {
  $("div.cl-error").html(`${data.errorCode} - ${data.errorMsg}`);
}

function registerSuccess(data) {
  $("div.cl-error").html(`${data.msg}`);
}

function registerFailed(data) {
  $("div.cl-error").html(`${data.errorCode} - ${data.errorMsg}`);
}

function bindRegisterMemberEvents(){
  $("form[name='wgc_register_frm'] input[name='register_member']").on("click", function(){
    registerMemberForm(this);
  });
  $("form[name='wgc_register_frm']").on("change", function(){
    $("form[name='wgc_register_frm'] div.register-error").html('');
  });
}

function registerMemberForm(ele){
  let url=`${rootUrl}/customer/registerUser`;
  let termConds=$("form[name='wgc_register_frm'] input[name='terms']").is(":checked");
  if(!termConds) {
    $("div.register-error").html(`${$("form[name='wgc_register_frm'] input[name='wgc_email']").data("terms-msg")}`);
    return;
  }
  let email = $("form[name='wgc_register_frm'] input[name='wgc_email']").val();
  if(!EmailValidator.validate(email)){
    $("div.register-error").html(`${$("form[name='wgc_register_frm'] input[name='wgc_email']").data("invalid-msg")}`);
    return;
  }
  if(!$("form[name='wgc_register_frm'] input[name='wgc_pwd']").val()){
    $("div.register-error").html(`${$("form[name='wgc_register_frm'] input[name='wgc_pwd']").data("invalid-msg")}`);
    return;
  }
  if(!$("form[name='wgc_register_frm'] input[name='retype_pwd']").val()){
    $("div.register-error").html(`${$("form[name='wgc_register_frm'] input[name='retype_pwd']").data("invalid-msg")}`);
    return;
  }
  if($("form[name='wgc_register_frm'] input[name='wgc_pwd']").val() != $("form[name='wgc_register_frm'] input[name='retype_pwd']").val()){
    $("div.register-error").html(`${$("form[name='wgc_register_frm'] input[name='retype_pwd']").data("invalid-msg")}`);
    return;
  }
  const hashPwd = $("form[name='wgc_register_frm'] input[name='wgc_pwd']").val();
  axios({url:url,method:'POST',data:{email: email, pwd: hashPwd, termconds: termConds}}).then(function(res) {
    if(res.data.status) $("div.register-error").html(`${res.data.msg}`);
    else $("div.register-error").html(`${res.data.errorCode} - ${res.data.errorMsg}`);
  }).catch(function(err){
    $("div.signin-popup").remove();
  });
}

function registerCustomer(ele){
  let url=`${rootUrl}/customer/registerUser`;
  let termConds=$("input[name='term_conds']").is(":checked");
  let email = $("input[name='reguser_email']").val();
  $("div.cl-error").html("");
  if(!EmailValidator.validate(email)){
    $("div.cl-error").html(`${$("input[name='reguser_email']").data("invalid-msg")}`);
    return;
  }
  if(!$("input[name='reguser_pwd']").val()){
    $("div.cl-error").html(`${$("input[name='reguser_pwd']").data("invalid-msg")}`);
    return;
  }
  if(!$("input[name='regretype_pwd']").val()){
    $("div.cl-error").html(`${$("input[name='reguser_pwd']").data("invalid-msg")}`);
    return;
  }
  if($("input[name='reguser_pwd']").val() != $("input[name='regretype_pwd']").val()){
    $("div.cl-error").html(`${$("input[name='regretype_pwd']").data("invalid-msg")}`);
    return;
  }
  const hashPwd = $("input[name='reguser_pwd']").val();
  axios({url:url,method:'POST',data:{email: email, pwd: hashPwd, termconds: termConds}}).then(function(res) {
    if(res.data.status) registerSuccess(res.data);
    else registerFailed(res.data);
  }).catch(function(err){
    $("div.signin-popup").remove();
  });
}

function loginCustomer(ele){
  let url=`${rootUrl}/customer/loginUser`;
  let rememberMe=$("input[name='user_remember']").is(":checked");
  const hashPwd = sha256($("input[name='user_pwd']").val());
  let email = $("input[name='user_email']").val();
  let requester = $("input[name='requester']").val();
  if((requester == 'cust_info') && (String(location.href).endsWith("/checkout"))) requester="from_checkout";
  $("div.cl-error").html("");
  if(!EmailValidator.validate(email)){
    $("div.cl-error").html(`${$("input[name='user_email']").data("invalid-msg")}`);
    return;
  }
  if(!$("input[name='user_pwd']").val()){
    $("div.cl-error").html(`${$("input[name='user_pwd']").data("invalid-msg")}`);
    return;
  }
  axios({url:url,method:'POST',data:{email: email, pwd: hashPwd, remember: rememberMe,requester: requester}}).then(function(res) {
    if(res.data.status) loginSuccess(res.data);
    else loginFailed(res.data);
  }).catch(function(err){
    $("div.signin-popup").remove();
  });
}

function loginSeller(ele){
  let url=`${rootUrl}/customer/loginUser`;
  let rememberMe=$("input[name='user_remember']").is(":checked");
  const hashPwd = sha256($("input[name='user_pwd']").val());
  let username = $("input[name='user_email']").val();
  let requester = $("input[name='requester']").val();
  if((requester == 'cust_info') && (String(location.href).endsWith("/checkout"))) requester="from_checkout";
  $("div.cl-error").html("");
  if(!$("input[name='user_pwd']").val()){
    $("div.cl-error").html(`${$("input[name='user_pwd']").data("invalid-msg")}`);
    return;
  }
  axios({url:url,method:'POST',data:{username: username, pwd: hashPwd, remember: rememberMe,requester: requester,loginAsSeller: 1}}).then(function(res) {
    if(res.data.status) loginSuccess(res.data);
    else loginFailed(res.data);
  }).catch(function(err){
    $("div.signin-popup").remove();
  });
}

function logoutCustomer(ele){
  let url=`${rootUrl}/customer/logoutUser`;
  axios({url:url,method:'POST',data:{}}).then(function(res) {
    if(res.data.status){
      location.href=`${rootUrl}/`;
    }
  }).catch(function(err){
    console.log(err);
  });
}

function logoutReseller(ele){
  let url=`${rootUrl}/wexseller/logout`;
  axios({url:url,method:'POST',data:{}}).then(function(res) {
    location.href=`${rootUrl}/`;
  }).catch(function(err){
    console.log(err);
  });
}

function gotoMyPage(ele){
  let mypageUrl=$("div#customer_logged_id").data("mypage");
  if(mypageUrl) {
    location.href=`${rootUrl}${mypageUrl}`;
    return;
  }
}

function forgotPwd(ele){
  let url=`${rootUrl}/customer/forgotPwd`;
  let email = $("input[name='user_email']").val();
  $("div.cl-error").html("");
  if(!EmailValidator.validate(email)){
    $("div.cl-error").html(`${$("input[name='user_email']").data("invalid-msg")}`);
    return;
  }
  axios({url:url,method:'POST',data:{email: email}}).then(function(res) {
    if(!res.data.status){
      $("div.cl-error").html(res.data.error);
    }else{
      $("div.cl-error").html(`${res.data.msg}`);
    }
  }).catch(function(err){
    console.log(err);
  });
}

function forgotResellerPwd(ele){
  let url=`${rootUrl}/customer/forgotPwd`;
  let username = $("input[name='user_email']").val();
  let requester = $("input[name='requester']").val();  
  $("div.cl-error").html("");
  if(!username){
    $("div.cl-error").html(`${$("input[name='user_email']").data("invalid-msg")}`);
    return;
  }
  axios({url:url,method:'POST',data:{username: username, requester: requester}}).then(function(res) {
    if(!res.data.status){
      $("div.cl-error").html(res.data.error);
    }else{
      $("div.cl-error").html(`${res.data.msg}`);
    }
  }).catch(function(err){
    console.log(err);
  });
}

function loadSubscriptionPopup() {
  var userAgent = navigator.userAgent;
  var bots = ganBots;
  var isBot = false;
  for (var i in bots) {
    if (String(userAgent).indexOf(bots[i]) != -1) {
      isBot = true;
      break;
    }
  }
  if (isBot) return;
  let url=`${rootUrl}/gan/getSubscriptionPopupForm`;
  axios({url:url,method:'GET',params:{pathname:window.location.pathname}}).then(function(res) {
    if(res.data.html) {
      $('body').append(res.data.html);
      $(".wrapper").fadeIn(500);
    }
  }).catch(function(err){
    console.log(err);
  });
}

window.loginWithFB = function(email, first_name, last_name, fbid) {
  let url=`/customer/loginFacebookUser`;
  let rememberMe=$("input[name='user_remember']").is(":checked");
  let requester = $("input[name='requester']").val();
  if((requester == 'cust_info') && (String(location.href).endsWith("/checkout"))) requester="from_checkout";
  axios({url:url,method:'POST',data:{
    email:email,
    first_name:first_name,
    last_name:last_name,
    fbid:fbid,
    remember: rememberMe,
    requester: requester
  }})
  .then(function(res) {
    if(res.data.status) loginSuccess(res.data);
    else loginFacebookFailed(res.data);
  }).catch(function(err){
    $("div.signin-popup").remove();
  });
}
function loginFacebookFailed(data) {
  const NOT_REGISTERED = 1010;
  if (data.errorCode && Number(data.errorCode) == NOT_REGISTERED) {
    $("div.signin-popup").remove();
    loadRegisterPopupWithPreInfo(data);
  } else loginFailed(data);
}

function loadRegisterPopupWithPreInfo(data){
  let url=`${rootUrl}/customer/getRegister`;
  if (data && data.responseData && data.responseData.email) {
    url += `?email=${data.responseData.email}`
  }
  axios({url:url,method:'GET'}).then(function(res) {
    bindCustomerToUI(res.data);
    if (data && data.errorCode) {
      $("div.cl-error").html(`${data.errorCode} - ${data.errorMsg}`);
    }
  }).catch(function(err){
    console.log(err);
  });
}

function resetAllCustomerFields() {
  $("input[name='first_name']").val('');
  $("input[name='last_name']").val('');
  $("input[name='address_1']").val('');
  $("input[name='address_2']").val('');
  $("input[name='postal_code']").val('');
  $("input[name='city']").val('');
  $("select[name='country_code']").val(0);
  $("input[name='first_name']").focus();
  return true;
}

function checkProductIsFv() {
  let productId = $("div.addcart img[name='product_detail']").data("pid");
  productId = isNaN(productId)?0:Number(productId);
  if (productId <= 0) return;
  let url=`${rootUrl}/product/wishlist/${productId}?ts=${new Date().getTime()}`;
  const filledHeartImg = $("div.addcart img[name='product_detail']").data("img-fill");
  const nofilledHeartImg = $("div.addcart img[name='product_detail']").data("img-nofill");
  axios({url:url,method:'GET'}).then(function(res) {
    if (res.data && res.data.status) {
      if (res.data.isFv) {
        $("div.addcart img[name='product_detail']").attr("src", filledHeartImg)
        $("div.addcart img[name='product_detail']").addClass("fv-remove", filledHeartImg)
        $("div.addcart img[name='product_detail']").removeClass("fv-add", filledHeartImg)
      } else {
        $("div.addcart img[name='product_detail']").attr("src", nofilledHeartImg)
        $("div.addcart img[name='product_detail']").removeClass("fv-remove", nofilledHeartImg)
        $("div.addcart img[name='product_detail']").addClass("fv-add", nofilledHeartImg)
      }
    }
    if (res.data && res.data.message) console.log(res.data.message)
  }).catch(function(err) {
    console.log(err)
  })
}

function renderAdditionalFullWishlist() {
  let queryString = window.location.search;
  let urlParams = new URLSearchParams(queryString);
  if (urlParams.get("isWishlistHidden")) return;
  let url=`${rootUrl}/product/wishListFullHtml?ts=${new Date().getTime()}`;
  axios({url:url,method:'GET'}).then(function(res) {
    if (res.data && res.data.status) {
      if (res.data.html) {
        let fvList = $("div.product-list-container div.prod-fv-list").parent();
        if (fvList.length) fvList.replaceWith(res.data.html)
        else $(res.data.html).insertBefore("div.wex-container div.tp-slider.wh-widget")
        $("div.product-cell.fv-item button.close-btn").on("click",function(evt){
          evt.stopPropagation();
          removefromfv(this,$(this).data("pid"));
        });

        // after reload wishlist => alert others component to reload
        globalEvent.emit("wishlist-reload");
      }
    }
    if (res.data && res.data.message) console.log(res.data.message)
  }).catch(function(err) {
    console.log(err)
  })
}

export {loadLoginPopup,logoutCustomer,bindMyPageEvents,loadSubscriptionPopup,bindRegisterMemberEvents,checkLoggedCustomer, gotoMyPage,checkProductIsFv,renderAdditionalFullWishlist,openSellerPopup};
